import { render } from "./adminuser.vue?vue&type=template&id=4550e1da"
import script from "./adminuser.vue?vue&type=script&lang=ts"
export * from "./adminuser.vue?vue&type=script&lang=ts"
script.render = render

export default script